/* @flow */
import * as React from 'react';
import { InfoItemsContext, InfoItemsContextValues } from './InfoItemsContext';
import { InfoItem } from './InfoItem';
import { Stacker, StackerProps } from '../Stacker';
import { FixMeLater } from '../../utils';

export interface InfoItemsProps extends StackerProps {
    /**
     * If `true`, bullet points will be displayed.
     */
    bullets?: boolean;

    /**
     * The child components.
     */
    children: React.ReactNode;

    /**
     * Permit additional properties which will be passed to the root node.
     */
    [x: string]: unknown;

    /**
     * A reference passed to the root element.
     */
    ref?: React.Ref<FixMeLater>;
}

export function InfoItems(props: Readonly<InfoItemsProps>): React.JSX.Element {
    const { bullets = false, children, headingText, ref, ...other } = props;

    const values: InfoItemsContextValues = React.useMemo(
        () => ({
            bullets,
        }),
        [bullets]
    );

    return (
        <InfoItemsContext.Provider value={values}>
            <Stacker ref={ref} component="ul" spacing={1} {...other}>
                {React.Children.map(children, (child) => {
                    return React.isValidElement(child) && child.type === InfoItem ? <li>{child}</li> : null;
                })}
            </Stacker>
        </InfoItemsContext.Provider>
    );
}
